export default {
    isLoggedIn(state) {
        return (state.user && state.user.id)
            ? true
            : false;
    },
    userHandle(state) {
        return (state.user && state.user.id)
            ? state.user.email
            : '';
    },
    getApps(state) {
        return state.apps.length ? state.apps : []
    },
    getImages(state) {
        return state.images.length ? state.images : []
    },
    getNotifications(state) {
        return state.notifications
    }
}